// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2bpyX","info":"Note_info__1tSEq","note":"Note_note__21_u0","actions":"Note_actions__12ZaG"};